import * as Yup from 'yup';

export const EMAIL_TEMPLATE_SCHEMA = Yup.object().shape({
  name: Yup.string().required('Required'),
  subject: Yup.string().required('Required'),
  body: Yup.string().required('Required'),
  isShared: Yup.boolean().default(false),
});

export type EMAIL_TEMPLATE_FORM = Yup.InferType<typeof EMAIL_TEMPLATE_SCHEMA>;
